import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { styled, useLongPress } from '../../../foundation';
import { RcIconButton } from '../../Buttons';
import { buttonWrapperStyle } from './styles';
var _RcDialPadButton = function (props) {
    var value = props.value, longPressValue = props.longPressValue, longPressDelay = props.longPressDelay, onKeyEffect = props.onKeyEffect, _a = props.externalWindow, externalWindow = _a === void 0 ? window : _a, rest = __rest(props, ["value", "longPressValue", "longPressDelay", "onKeyEffect", "externalWindow"]);
    var isPressEvent = typeof longPressDelay === 'number' && typeof longPressValue === 'string';
    var _b = useLongPress({
        onTap: function (e, reason) {
            onKeyEffect(value, reason);
        },
        onPress: isPressEvent
            ? function (e, reason) {
                onKeyEffect(longPressValue, reason);
            }
            : undefined,
    }, rest, { delay: longPressDelay, externalWindow: externalWindow }), ref = _b.ref, events = __rest(_b, ["ref"]);
    return (React.createElement(RcIconButton, __assign({ ref: ref, variant: "round", stretchIcon: true }, rest, events)));
};
var RcDialPadButton = styled(_RcDialPadButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), buttonWrapperStyle);
RcDialPadButton.displayName = 'RcDialPadButton';
export { RcDialPadButton };
var templateObject_1;
